// Copyright Epic Games, Inc. All Rights Reserved.
import { Link, useNavigate } from "@remix-run/react";

interface Pager {
	items: number;
	currentPage: number;
	pageSize: number | undefined;
}

const Pagination = ({ items, pageSize }: Pager): React.ReactNode => {
	const realPageSize = pageSize || 1;
	const pagesCount = Math.ceil(items / realPageSize);
	const navigate = useNavigate();

	if (pagesCount === 1)
		return (
			<div className="container mb-5">
				<nav className="pagination" role="navigation" aria-label="pagination"></nav>
			</div>
		);
	const pages = Array.from({ length: pagesCount }, (_, i) => i + 1);

	const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, pageNum: number): void => {
		e.preventDefault();
		navigate(`/news?page=${pageNum}`);
	};

	return (
		<div className="container mb-5">
			<nav className="pagination" role="navigation" aria-label="pagination">
				<ul className="pagination-list is-justify-content-center">
					{pages.map((pageNum) => (
						<li key={pageNum}>
							<Link
								className={`pagination-link`}
								onClick={(e) => handleClick(e, pageNum)}
								to={{
									pathname: `/news`,
									search: `?${new URLSearchParams({ page: `${pageNum}` })}`,
								}}
							>
								{pageNum}
							</Link>
						</li>
					))}
				</ul>
			</nav>
		</div>
	);
};

export default Pagination;
